/** Application bootstrap: build the router over `#app` and start it. */
import { Router } from './router';
import { renderNotFound, routes } from './routes';
import { loadAppConfig } from './auth';
import { toastError } from '../ui/toast';

export function startApp(host: HTMLElement): Router {
  // Warm the deployment's capability list; pages that care await it themselves.
  void loadAppConfig();

  const router = new Router({
    host,
    routes,
    notFound: renderNotFound,
    onError: (err) => {
      console.error(err);
      toastError(err);
    },
  });
  router.start();
  return router;
}
